import {ChangeDetectorRef, Component, HostListener, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {TreatmentEndoDataModel} from '../../models/treatment-endo-data.model';
import {TreatmentEndoCanalDataModel} from '../../models/treatment-endo-canal-data.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TreatmentEndoEditColumnModel} from '../../models/treatment-endo-edit-column.model';
import {TreatmentEndoCanalEnumService} from '../../treatment-endo-canal-enum.service';
import {TreatmentService} from '../../../../services/treatment.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {TdoDropdownModel} from '../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {fromEvent, Subscription} from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { enumValidValueItem } from 'src/app/modules/ar/_models/ar.models';
import { EditEnumDialogComponent } from 'src/app/dialog/edit-enum-dialog/edit-enum-dialog.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ARService } from 'src/app/modules/ar/ar.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  standalone: false,
    selector: 'app-treatment-endo-edit-row-dialog',
    templateUrl: './treatment-endo-edit-row-dialog.component.html',
    styleUrls: ['./treatment-endo-edit-row-dialog.component.scss']
})
export class TreatmentEndoEditRowDialogComponent implements OnInit {
    @ViewChild('enumOptionsMenu') enumOptionsMenu: TemplateRef<any>;
    isLoading = true;

    treatmentModel: TreatmentEndoDataModel;
    canalModel: TreatmentEndoCanalDataModel;

    estimatedWorkLengthEnumsArray: EnumValidValueItemModel[][] = [];
    originalEstimatedWorkLengthEnumsArray: EnumValidValueItemModel[][] = [];
    filterEstimatedWorkLengthEnumsArray: EnumValidValueItemModel[][] = [];

    fillTypeDropdownModels: TdoDropdownModel[];
    fillBrandDropdownModels: TdoDropdownModel[];
    fillSizeDropdownModels: TdoDropdownModel[];

    validValueItems: EnumValidValueItemModel[];
    TreatmentEwlAwlFilter: string = 'TreatmentEwlAwlFilter';
    isTreatmentEwlAwlFilter: boolean = false;
    enumPropertyName: string;

    isContextOpen: boolean = false;
    private overlayRef: OverlayRef | null;
    private sub: Subscription;

    @HostListener('contextmenu', ['$event'])
    onContextMenu(event: MouseEvent, enumValue?: EnumValidValueItemModel[]): void {
        this.onRightMouseClick(event, enumValue, this.enumPropertyName);
    }

    constructor(@Inject(MAT_DIALOG_DATA) private data,
                public enumService: TreatmentEndoCanalEnumService,
                private treatmentService: TreatmentService,
                private overlay: Overlay,
                private dialog: MatDialog,
                private viewContainerRef: ViewContainerRef,
                private dialogRef: MatDialogRef<TreatmentEndoEditRowDialogComponent>,
                private localStorageService: LocalStorageService,
                private arService: ARService,
                private snackBar: MatSnackBar, 
                private cd: ChangeDetectorRef) {
        this.treatmentModel = data.treatmentModel;
        this.canalModel = data.canalModel;
    }

    ngOnInit(): void {
        this.isLoading = false;

        const numEstimatedEnums = this.enumService.estimatedWorkLengthEnums.length;
        const splitIndex = Math.floor(numEstimatedEnums / 2);
        const enums = this.enumService.estimatedWorkLengthEnums.concat();
        const firstSplit = enums.slice(0, enums.length - splitIndex);
        const secondSplit = enums.slice(splitIndex);
        this.originalEstimatedWorkLengthEnumsArray.push(firstSplit);
        this.originalEstimatedWorkLengthEnumsArray.push(secondSplit);
        this.filterEstimatedWorkLengthEnumsArray.push(firstSplit.filter(p => !p.ItemDisplayValue.endsWith('5')));
        this.filterEstimatedWorkLengthEnumsArray.push(secondSplit.filter(p => !p.ItemDisplayValue.endsWith('5')));
        this.estimatedWorkLengthEnumsArray = this.originalEstimatedWorkLengthEnumsArray;
        // this.estimatedWorkLengthEnumsArray.push(this.enumService.estimatedWorkLengthEnums.(splitIndex))
        console.log('test');

        this.fillTypeDropdownModels = this.createDropdownModelsFromEnum(this.enumService.fillTypeEnums);
        this.fillBrandDropdownModels = this.createDropdownModelsFromEnum(this.enumService.fillBrandEnums);
        this.fillSizeDropdownModels = this.createDropdownModelsFromEnum(this.enumService.fillSizeEnums);

        this.isTreatmentEwlAwlFilter = localStorage.getItem('isTreatmentEwlAwlFilter') === 'true';

        if (this.isTreatmentEwlAwlFilter){
            this.estimatedWorkLengthEnumsArray = this.filterEstimatedWorkLengthEnumsArray;
        }
    }

    onOkClick() {
        this.dialogRef.close();
    }

    onCancelClick() {
        this.dialogRef.close();
    }

    getDocumentFormToothNumber() {
        if (this.treatmentModel) {
            return this.treatmentModel.cfgTeeth[0].cfgToothDescriptions[0].Notation;
        } else {
            return null;
        }
    }

    onRightMouseClick(event: MouseEvent, enumValue: any , enumPropertyName: string) {

        this.enumPropertyName = enumPropertyName;

        if (enumValue === undefined ) {
            return;
        }
        if (enumValue === undefined || enumValue[0].enumValidValue.isSystem) {
            event.preventDefault();
            this.createMessage('This list is a system list: can not be edit! (contact support)', 'Info');

            return;
        }

        event.preventDefault();
        this.validValueItems = enumValue;
        this.openContext(event, this.enumOptionsMenu, enumValue);
    }

    onFilterByLenght(event: MatCheckboxChange)
    {
        if (event.checked) {
            this.estimatedWorkLengthEnumsArray = this.filterEstimatedWorkLengthEnumsArray;
            this.saveFilterParamsToDB('true');
            localStorage.setItem('isTreatmentEwlAwlFilter', 'true');
        } else {
            this.estimatedWorkLengthEnumsArray = this.originalEstimatedWorkLengthEnumsArray;
            this.saveFilterParamsToDB('false');
            localStorage.setItem('isTreatmentEwlAwlFilter', 'false');
        }
    }


    saveFilterParamsToDB(isActive: string) {
        const userId = this.localStorageService.currentUserData.authdata.userid;
        this.arService.saveUserParams(isActive, userId, this.TreatmentEwlAwlFilter).subscribe(saved => {
            if (saved) {
                // save successful
                this.createMessage('Filter settings saved', 'Success');
            }
        }, err => {
            this.createMessage('Error saving filter settings', 'Error');
        });
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
        this.isContextOpen = true;
        this.closeContext();
        x = x + 50;
        y = y - 20;
        const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

        this.sub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(event => {
                    if (closeOnItemClick) {
                        this.closeContext();
                    } else {
                        const clickTarget = event.target as HTMLElement;
                        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                    }
                }), take(1)).subscribe(() => this.closeContext());
    }

    onEditList() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.validValueItems;

        this.dialog.open(EditEnumDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {
                this.validValueItems = [];

                setTimeout(() => {
                    

                    
                    this.validValueItems = res;


                    let z = this.enumService[this.enumPropertyName][0].enumValidValue;

                
                    this.enumService[this.enumPropertyName]= res.filter(p => p.xauditDeleted === false  );
                    this.enumService[this.enumPropertyName][0].enumValidValue = z;

                    this.cd.detectChanges();

                }, 100);
            }
        });
    }

    closeContext(): void {
        this.sub !== undefined && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.isContextOpen = false;
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    isSelectedItem(enu: EnumValidValueItemModel, enumPropertyName: string) {
        return this.canalModel[enumPropertyName] === enu.ValidValueItemId;
    }

    

    onItemClick(enu: EnumValidValueItemModel, enumPropertyName: string) {
    
        
    
        if (this.canalModel[enumPropertyName] === enu.ValidValueItemId)  {
            this.canalModel[enumPropertyName] = null;
        }
        else {
            this.canalModel[enumPropertyName] = enu.ValidValueItemId;
        }

        // this.canalModel[enumPropertyName] = enu.ValidValueItemId;
        this.treatmentService.saveCanalItem(this.canalModel).subscribe((res) => {
            // this.canalModel = res;
        });
    }

    getCanalType() {
        if (this.canalModel) {
            const enu = this.enumService.toothCanalEnums.find(p => p.ValidValueItemId === this.canalModel.enumToothCanalID);
            if (enu) {
                return enu.ItemDisplayValue;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    createDropdownModelsFromEnum(enums: EnumValidValueItemModel[]) {
        const dds: TdoDropdownModel[] = [];
        for (const enu of enums) {
            dds.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
        }
        return dds;
    }

    getDropdownValue(fillTypeDropdownModels: TdoDropdownModel[], enumId: string) {


        try {
            if (fillTypeDropdownModels && enumId) {
                const model = fillTypeDropdownModels.find(p => p.value.ValidValueItemId === this.canalModel[enumId]);
                if (model) {
                    return model.value.ValidValueItemId;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } catch (error) {
            
        }
    }

    onDropdownSelected(event: EnumValidValueItemModel, enumPropertyName: string) {
        this.canalModel[enumPropertyName] = event.ValidValueItemId;
        this.treatmentService.saveCanalItem(this.canalModel).subscribe((res) => {
        });
    }

    onNumUsesInputFinished(event: string) {
        this.canalModel.FillNumberOfUses = parseInt(event);
        this.treatmentService.saveCanalItem(this.canalModel).subscribe((res) => {
            //
        });
    }
}
